<template>
  <form @submit.prevent="submit">
    <fg-input label="Vorname"
      type="text"
      v-model="contactPerson.first_name"
      :error="valErrors['first_name'] ? valErrors['first_name'][0] : null"
    />
    <fg-input label="Nachname"
      type="text"
      v-model="contactPerson.last_name"
      :error="valErrors['last_name'] ? valErrors['last_name'][0] : null"
    />
    <fg-input label="E-Mail Adresse"
      type="email"
      v-model="contactPerson.email"
      :error="valErrors['email'] ? valErrors['email'][0] : null"
    />
    <fg-input label="E-Mail Anrede">
      <textarea class="form-control" v-model="contactPerson.anrede_email" rows="3"></textarea>
    </fg-input>
    <fg-input label="Telefonnummer"
      type="text"
      v-model="contactPerson.tel"
      :error="valErrors['tel'] ? valErrors['tel'][0] : null"
    />
    <fg-input label="Faxnummer"
      type="text"
      v-model="contactPerson.fax"
      :error="valErrors['fax'] ? valErrors['fax'][0] : null"
    />
    <button type="submit" class="btn btn-fill btn-info">{{ submitText }}</button>
  </form>
</template>

<script>
export default {
  props: ['valErrors', 'initContactPerson', 'submitText'],
  data () {
    return {
      contactPerson: this.initContactPerson
    }
  },
  methods: {
    submit () {
      this.$emit('submit', this.contactPerson)
    }
  }
}
</script>

<style>
</style>
